import React, { useState } from "react";
import "./App.css";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import ProcessSection from "./components/ProcessSection";
import ServiceAreasSection from "./components/ServiceAreasSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CommitmentsSection from "./components/CommitmentsSection";
import EstimateModal from "./components/EstimateModal";
import Footer from "./components/Footer";

function App() {
  const [isEstimateModalOpen, setIsEstimateModalOpen] = useState(false);

  const openEstimateModal = () => setIsEstimateModalOpen(true);
  const closeEstimateModal = () => setIsEstimateModalOpen(false);

  return (
    <div className="App">
      <Header onGetEstimate={openEstimateModal} />
      <main>
        <HeroSection onGetEstimate={openEstimateModal} />
        <ServicesSection onGetEstimate={openEstimateModal} />
        <ProcessSection onGetEstimate={openEstimateModal} />
        <ServiceAreasSection />
        <TestimonialsSection />
        <CommitmentsSection />
      </main>
      <Footer onGetEstimate={openEstimateModal} />
      
      {/* Estimate Modal */}
      <EstimateModal 
        isOpen={isEstimateModalOpen} 
        onClose={closeEstimateModal} 
      />
    </div>
  );
}

export default App;
